import React from 'react'
import { List, Switch, Typography, Space, Button } from 'antd'

const { Title, Text } = Typography

interface FeatureManagementProps {
    onSave: (values: any) => void
}

export const FeatureManagement: React.FC<FeatureManagementProps> = ({ onSave }) => {
    const features = [
        {
            key: 'enable_rfq',
            title: 'RFQ System',
            description: 'Allow merchants to respond to Requests for Quotes',
            enabled: true,
        },
        {
            key: 'enable_chat',
            title: 'Live Chat',
            description: 'Enable real-time chat between customers and merchants',
            enabled: true,
        },
        {
            key: 'enable_reviews',
            title: 'Product Reviews',
            description: 'Allow customers to leave reviews on products',
            enabled: false,
        },
        {
            key: 'enable_dark_mode',
            title: 'Dark Mode (Beta)',
            description: 'Enable dark mode toggle for end-users',
            enabled: true,
        },
    ]

    return (
        <div>
            <Title level={4}>Feature Flags</Title>
            <Text type="secondary" style={{ display: 'block', marginBottom: 24 }}>
                Manage the availability of features across the platform. Changes apply immediately.
            </Text>

            <List
                itemLayout="horizontal"
                dataSource={features}
                renderItem={(item) => (
                    <List.Item
                        actions={[
                            <Switch defaultChecked={item.enabled} onChange={() => { }} />
                        ]}
                    >
                        <List.Item.Meta
                            title={item.title}
                            description={item.description}
                        />
                    </List.Item>
                )}
            />

            <div style={{ marginTop: 24 }}>
                <Button type="primary" onClick={() => onSave({})}>Save Changes</Button>
            </div>
        </div>
    )
}
